import React from "react";
import { ShieldAlert } from "lucide-react";

export default function ScopeOfPractice() {
  return (
    <div className="bg-sage/20 border border-sage rounded-lg p-6 md:p-8" data-testid="scope-of-practice">
      <div className="flex items-start gap-4">
        <ShieldAlert className="text-earth shrink-0 mt-1" size={24} />
        <div>
          <h3 className="text-xl text-earth mb-2">A note on scope of practice</h3>
          <p className="text-earth/80 leading-relaxed">
            Constellation work is an experiential, complementary modality. It is
            <strong> not a substitute</strong> for medical or psychiatric treatment or
            medication, and it is <strong>not appropriate as sole care during an acute
            mental health crisis</strong>. If you are in crisis, please contact a qualified
            medical professional, or a mental health helpline, without delay.
          </p>
        </div>
      </div>
    </div>
  );
}
